/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProjectResourceFreelancerRateResource } from './';
import {
    ProjectResourceFreelancerRateResourceFromJSON,
    ProjectResourceFreelancerRateResourceFromJSONTyped,
    ProjectResourceFreelancerRateResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectResource
 */
export interface ProjectResource {
    /**
     * 
     * @type {string}
     * @memberof ProjectResource
     */
    projectId: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectResource
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectResource
     */
    projectType: ProjectResourceProjectTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ProjectResource
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectResource
     */
    status: ProjectResourceStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ProjectResource
     */
    totalPriceExcludingTaxes: number;
    /**
     * 
     * @type {Date}
     * @memberof ProjectResource
     */
    endDate?: Date;
    /**
     * 
     * @type {ProjectResourceFreelancerRateResource}
     * @memberof ProjectResource
     */
    freelancerRate?: ProjectResourceFreelancerRateResource;
}


/**
 * @export
 */
export const ProjectResourceProjectTypeEnum = {
    FixedPrice: 'FIXED_PRICE',
    TimeAndMaterials: 'TIME_AND_MATERIALS'
} as const;
export type ProjectResourceProjectTypeEnum = typeof ProjectResourceProjectTypeEnum[keyof typeof ProjectResourceProjectTypeEnum];

/**
 * @export
 */
export const ProjectResourceStatusEnum = {
    Canceled: 'CANCELED',
    Ended: 'ENDED',
    InProgress: 'IN_PROGRESS'
} as const;
export type ProjectResourceStatusEnum = typeof ProjectResourceStatusEnum[keyof typeof ProjectResourceStatusEnum];


/**
 * Check if a given object implements the ProjectResource interface.
 */
export function instanceOfProjectResource(value: object): value is ProjectResource {
    if (!('projectId' in value) || value['projectId'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('projectType' in value) || value['projectType'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('totalPriceExcludingTaxes' in value) || value['totalPriceExcludingTaxes'] === undefined) return false;
    return true;
}

export function ProjectResourceFromJSON(json: any): ProjectResource {
    return ProjectResourceFromJSONTyped(json, false);
}

export function ProjectResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectResource {
    if (json == null) {
        return json;
    }
    return {
        
        'projectId': json['projectId'],
        'currency': json['currency'],
        'projectType': json['projectType'],
        'title': json['title'],
        'status': json['status'],
        'totalPriceExcludingTaxes': json['totalPriceExcludingTaxes'],
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'freelancerRate': json['freelancerRate'] == null ? undefined : ProjectResourceFreelancerRateResourceFromJSON(json['freelancerRate']),
    };
}

export function ProjectResourceToJSON(value?: ProjectResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'projectId': value['projectId'],
        'currency': value['currency'],
        'projectType': value['projectType'],
        'title': value['title'],
        'status': value['status'],
        'totalPriceExcludingTaxes': value['totalPriceExcludingTaxes'],
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString().substring(0,10)),
        'freelancerRate': ProjectResourceFreelancerRateResourceToJSON(value['freelancerRate']),
    };
}

